import type { ShipperUser } from './types';

// Minimal login-shaped input (nsdk UserDataLoginRecord and peers). Keeps
// observability free of an nsdk dependency while deduping web/RN mappers.
export type ShipperUserSource = {
  id: string | number;
  email?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  isWorker?: boolean | null;
};

export const toShipperUser = (user: ShipperUserSource): ShipperUser => ({
  id: String(user.id),
  email: user.email,
  phoneNumber: user.phoneNumber,
  firstName: user.firstName,
  lastName: user.lastName,
  isWorker: Boolean(user.isWorker)
});
